import s from "./RecentActivityWidgetModal.module.scss"

export const RecentActivityWidgetModalSkeleton = () => {
  return (
    <div className={s.skeleton}>
      <div className={s.skeleton__top}>
        <div className={s.skeleton__icon} />
        <div className={s.skeleton__title} />
      </div>
      <ul className={s.skeleton__entries}>
        <SkeletonEntry />
        <SkeletonEntry />
        <SkeletonEntry />
      </ul>
    </div>
  )
}

const SkeletonEntry = () => (
  <li className={s.skeletonEntry}>
    <div className={s.skeletonEntry__avatar} />
    <div className={s.skeletonEntry__title} />
    <div className={s.skeletonEntry__summary} />
  </li>
)
